import {FC} from "react";
import {SearchIcon, SearchInput, SearchInputWrapper} from "./styles";
import ImgSearchIcon from "../assets/images/search-icon.svg";
import ImgCloseIconX from "../assets/images/icon-x.svg";

interface IProps {
  searchInputRef: any;
  inputSearchValue: string;
  handleTypeSearch?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setInputSearchValue: React.Dispatch<React.SetStateAction<string>>;
  isOpenPanel?: boolean;
  placeholder?: string;
  isIconSearch?: boolean;
  isNoBorder?: boolean;
}

export const SearchInputCustom: FC<IProps> = ({
  searchInputRef,
  inputSearchValue,
  handleTypeSearch,
  setInputSearchValue,
  isOpenPanel = true,
  placeholder = "Поиск...",
  isIconSearch = true,
  isNoBorder = false,
}) => {
  return (
    <SearchInputWrapper isopenpanel={isOpenPanel} isnoborder={isNoBorder}>
      <SearchInput
        ref={searchInputRef}
        type="text"
        placeholder={placeholder}
        value={inputSearchValue}
        onChange={(e) => handleTypeSearch?.(e)}
      />
      {isIconSearch &&
        (inputSearchValue.length > 0 ? (
          <SearchIcon
            src={ImgCloseIconX}
            alt="close"
            onClick={() => setInputSearchValue("")}
          />
        ) : (
          <SearchIcon src={ImgSearchIcon} alt="search" />
        ))}
    </SearchInputWrapper>
  );
};
